import { ActionTree, Action } from 'vuex';
import { RootState } from '@/store/types/root.state';
import { ArtistViewState } from '@/store/types/artistView.state';
import db from "@/firebase";
import Artist from "@/models/artist";
import Artwork from "@/models/artwork";

export const actions: ActionTree<ArtistViewState, RootState> = {
    
    fetchArtist({commit}, id: string){
        db.collection('artists').doc(id).onSnapshot((item) => {
            commit('setLoading', true);
            const artist = new Artist();
            const data = item.data();
            if(data!=null){
                artist.name = data.name;
                artist.description = data.description;
                artist.imageURL = data.imageURL;
                if(data.birthDate!=null){
                    artist.birthDate = data.birthDate.toDate();
                    artist.birthYear = data.birthDate.toDate().getFullYear();
                }
                if(data.deathDate!=null){
                    artist.deathDate = data.deathDate.toDate();
                    artist.deathYear = data.deathDate.toDate().getFullYear();
                }
                artist.birthCity = data.birthCity;
                artist.deathCity = data.deathCity;
                artist.scale = data.scale;
                artist.links = data.links;
                artist.id = item.id;
            }
            commit('setArtist', artist);
            commit('setLoading', false)
        });
    },
    fetchArtistArtworks( {commit, state}){
        const artworks: Artwork[] = [];
        db.collection('artworks').onSnapshot((data) => {
            commit('setLoading', true);
            data.docs.map( (item, i) => {
                if(item.data().author.id == state.artist.id){
                    const artwork = new Artwork();
                    artwork.title = item.data().title;
                    artwork.imageURL = item.data().imageURL;
                    artwork.author = item.data().author;
                    artwork.type = item.data().type;
                    artwork.description = item.data().description;
                    artwork.id = item.id;
                    artwork.authorId = item.data().author.id;
                    artwork.authorName = state.artist.name;
                    artwork.date = item.data().date.toDate().getFullYear();
                    artworks.push(artwork);
                }
            })
            commit('setArtistArtworks', artworks);
            commit('setLoading', false)
        });
    },

    fetchData({commit, dispatch}, id: string){
        dispatch('fetchArtist', id);
        dispatch('fetchArtistArtworks');
    }


}